module.exports = __webpack_public_path__ + "static/media/flight2.ff8f211a.svg";